import * as React from 'react';

import { Button } from 'antd';
import { FileDoneOutlined } from '@ant-design/icons';
import { useAppRoutes } from '@/hooks';
import { useAppSelector } from '@/types/reduxHelpers';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface SaveOfflineAttendanceButtonProps {

}

export const SaveOfflineAttendanceButton: React.FC<SaveOfflineAttendanceButtonProps> = (props) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const appRoutes = useAppRoutes();

    const completedEmergencyAttendance = useAppSelector((state) => state.offlineEmergencyAttendance.completedEmergencyAttendance);

    return (
        <Button
            style={{ width: '100%' }}
            icon={<FileDoneOutlined />}
            type="default"
            danger={true}
            onClick={() => navigate(appRoutes.saveOfflineEmergencyAttendance.path)}
            disabled={!completedEmergencyAttendance}
        >
            {t('Components.SaveOfflineAttendanceButton.button_text')}
        </Button>
    );
};